/*
 * sc-pdp-swatch-fix.js  —  Vogain (31aab4-2) theme patch, store-scoped.
 *
 * PRODUCT PAGE. ScaleChart skips a colour option that has only ONE value
 * (nothing to pick), so single-colour products — e.g. "Womens Dress Halter Neck
 * Floral Maxi A-Line", colour "Light Blue" — render the colour as a bare text
 * pill with no swatch, while multi-colour products get proper image swatches.
 *
 * This patch gives those single-value colour options the SAME swatch the
 * multi-colour products get: the label itself becomes a ~64px rounded image
 * swatch of that colour's variant photo (solid colour from the name, then a
 * neutral, as fallbacks — never text-only), with the selected-state border.
 *
 * Anti-flicker: the option is masked (visibility:hidden) from first paint until
 * we've styled it, so the viewer never sees the text-pill -> swatch transition
 * or ScaleChart's brief hide/show of the label row.
 */
(function () {
  'use strict';
  if (window.__scPdpSwatchFix) return;
  window.__scPdpSwatchFix = true;

  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var COLOR_RE = /^(colou?r|farbe|couleur|kleur|colore|farve|f(a|ä)rg|väri|cor|renk)$/i;

  /* ---- flicker mask ---- the .sc-pdp-fixing class + CSS are set inline in
     <head> (theme.liquid) so a single-value colour option is hidden from first
     paint; we drop the class as soon as the swatch is styled. ---------------- */
  var unmasked = false;
  function unmask() {
    if (unmasked) return;
    unmasked = true;
    try { document.documentElement.classList.remove('sc-pdp-fixing'); } catch (e) {}
  }
  setTimeout(unmask, 2400); // failsafe (head has its own 2500ms backstop)

  /* ---- colour dictionary (solid fallback only) ---- */
  var HEX = {
    black: '#1a1a1a', white: '#ffffff', ivory: '#f4efe2', cream: '#f3ead6', beige: '#e3d3b8',
    nude: '#e6c9b3', tan: '#c8a97e', camel: '#b98d54', khaki: '#8f8563', brown: '#6d5237',
    grey: '#8b8b8b', gray: '#8b8b8b', charcoal: '#3f4145', silver: '#c8c9cc',
    red: '#b3322c', burgundy: '#6e2f38', maroon: '#6e2f38', wine: '#6e2f38', rust: '#a85a36',
    pink: '#e6a9bd', 'hot pink': '#d94f89', rose: '#c8798c', blush: '#e7c3c8', coral: '#e2745f',
    peach: '#f0c4a6', apricot: '#e8b384', orange: '#d17b34', mustard: '#c69a3e', gold: '#c1a253',
    yellow: '#e2c04f', lime: '#9cbb3b', green: '#4a7a55', sage: '#9aab8c', olive: '#6a6e42',
    'dark green': '#2f4a37', forest: '#2f4a37', mint: '#bcdcc7', teal: '#2f6f73', turquoise: '#4aa8a3',
    'light blue': '#a9cfe3', 'sky blue': '#9cc0dd', 'baby blue': '#bcd7e8', blue: '#3a5a82',
    navy: '#25324d', 'dark blue': '#1e2b44', denim: '#4a6582', periwinkle: '#9aa3d8',
    purple: '#6a4a86', violet: '#6a4a86', lavender: '#c2b4dc', lilac: '#c9bce0', plum: '#5d3f5b',
    chocolate: '#49352a', taupe: '#b3a495'
  };
  function hexFor(name) {
    var k = String(name || '').toLowerCase().trim();
    if (HEX[k]) return HEX[k];
    var keys = Object.keys(HEX).sort(function (a, b) { return b.length - a.length; });
    for (var i = 0; i < keys.length; i++) if (k.indexOf(keys[i]) !== -1) return HEX[keys[i]];
    return null;
  }

  function isProductPage() {
    if (document.body && /(^|\s)template-product(\s|$)/.test(document.body.className || '')) return true;
    return /\/products\/[^\/?#]+/.test(location.pathname);
  }
  function currentHandle() {
    try {
      var h = window.ShopifyAnalytics && ShopifyAnalytics.meta && ShopifyAnalytics.meta.product && ShopifyAnalytics.meta.product.handle;
      if (h) return h;
    } catch (e) {}
    var m = location.pathname.match(/\/products\/([a-zA-Z0-9_-]+)/);
    return m ? m[1] : '';
  }

  var prod = null, prodDone = false, prodWaiters = [];
  function loadProduct(cb) {
    if (prodDone) { cb(prod); return; }
    prodWaiters.push(cb);
    if (prodWaiters.length > 1) return;
    var done = function (p) { prod = p; prodDone = true; prodWaiters.splice(0).forEach(function (f) { f(p); }); };
    var h = currentHandle();
    if (!h) { done(null); return; }
    fetch(ROOT + 'products/' + h + '.js').then(function (r) { return r.json(); }).then(done).catch(function () { done(null); });
  }
  function colorImageMap(p) {
    var map = {};
    if (!p || !p.options || !p.variants) return map;
    var names = p.options.map(function (o) { return typeof o === 'string' ? o : (o && o.name) || ''; });
    var idx = -1;
    for (var i = 0; i < names.length; i++) { if (COLOR_RE.test((names[i] || '').trim())) { idx = i; break; } }
    if (idx < 0 && names.length === 1) idx = 0;
    if (idx < 0) return map;
    var firstImg = typeof p.featured_image === 'string' ? p.featured_image : (p.featured_image && p.featured_image.src) || '';
    p.variants.forEach(function (v) {
      var val = v.options ? v.options[idx] : v['option' + (idx + 1)];
      if (!val) return;
      var k = String(val).toLowerCase();
      if (!map[k]) map[k] = (v.featured_image && v.featured_image.src) || firstImg || '';
    });
    return map;
  }

  function legendColorName(fs) {
    var lg = fs.querySelector('legend, .form__label, .variant__label');
    return lg ? String(lg.textContent || '').split(/[—–-]/)[0].trim().toLowerCase() : '';
  }

  /* ---- observer that ignores our own writes ---- */
  var observer = null;
  function obsTarget() { return document.querySelector('variant-picker, .variant-picker') || document.body; }
  function muted(fn) {
    try { if (observer) observer.disconnect(); } catch (e) {}
    try { fn(); } finally { try { if (observer) observer.observe(obsTarget(), { childList: true, subtree: true }); } catch (e) {} }
  }

  // Style the <label> itself as the swatch — same look as the multi-colour image
  // swatches: ~64px rounded square, selected-state border with a small inset gap.
  function swatchCss(bg) {
    return 'display:block !important;box-sizing:border-box !important;'
      + 'width:64px !important;height:64px !important;min-width:0 !important;'
      + 'padding:2px !important;margin:4px 0 !important;'
      + 'border:1px solid #111 !important;border-radius:var(--input-border-radius,6px) !important;'
      + 'background:' + bg + ' !important;background-size:cover !important;'
      + 'background-clip:content-box !important;background-origin:content-box !important;'
      + 'overflow:hidden !important;cursor:default !important;box-shadow:none !important;';
  }
  function imgBg(src) { return '#fff center/cover no-repeat url(' + src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=160)'; }

  function restoreRow(fs) {
    var info = fs.querySelector('.variant-picker__option-info');
    if (info && info.style.display !== 'flex') {
      info.style.setProperty('display', 'flex', 'important');
      info.removeAttribute('data-sc-hidden-empty');
    }
    var lg = fs.querySelector('legend');
    if (lg && lg.style.display !== 'block') lg.style.setProperty('display', 'block', 'important');
  }

  // returns true if this fieldset is a single-value colour option (handled)
  function decorate(fs) {
    var vals = fs.querySelector('.variant-picker__option-values');
    if (!vals) return false;
    var labels = [].filter.call(vals.querySelectorAll('label'), function (l) { return !l.querySelector('input'); });
    if (labels.length !== 1) return false;
    var label = labels[0];

    restoreRow(fs);

    if (!label.hasAttribute('data-sc-pdpfix')) {
      var span = label.querySelector('span');
      var val = ((span && span.textContent) || label.textContent || '').trim();
      if (span) span.style.cssText = 'position:absolute;width:1px;height:1px;overflow:hidden;clip:rect(0 0 0 0);white-space:nowrap;';
      label.style.cssText = swatchCss(hexFor(val) || '#d9d9d9');
      label.setAttribute('data-sc-pdpfix', '1');
      label.setAttribute('data-sc-val', val.toLowerCase());
    }

    if (label.getAttribute('data-sc-photo') !== 'done') {
      var lbl = label;
      loadProduct(function (p) {
        var src = colorImageMap(p)[lbl.getAttribute('data-sc-val')];
        muted(function () { if (src) lbl.style.cssText = swatchCss(imgBg(src)); });
        lbl.setAttribute('data-sc-photo', 'done');
        unmask();
      });
    }
    return true;
  }

  function run() {
    if (!isProductPage()) { unmask(); return; }
    var groups = document.querySelectorAll('fieldset.variant-picker__option, .variant-picker__option');
    var sawColour = false, handled = false;
    muted(function () {
      for (var i = 0; i < groups.length; i++) {
        if (!COLOR_RE.test(legendColorName(groups[i]))) continue;
        sawColour = true;
        if (decorate(groups[i])) handled = true;
      }
    });
    // No single-value colour option here (or none at all) -> nothing to wait for.
    if (!handled) unmask();
  }

  var t = null;
  function schedule() { if (t) return; t = setTimeout(function () { t = null; run(); }, 120); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  setTimeout(run, 700);   // catch ScaleChart's async hide of the label row
  try {
    observer = new MutationObserver(schedule);
    observer.observe(obsTarget(), { childList: true, subtree: true });
  } catch (e) {}
})();
